export const bgConstants = {
  GET_BUSI_SUCCESS: "GET_BUSI_SUCCESS",
  GET_BUSI_FAILURE: "GET_BUSI_FAILURE",
  GET_BG_FILTER_REQUEST: "GET_BG_FILTER_REQUEST",
  GET_BG_FILTER: "GET_BG_FILTER",
  LEGEND_TOGGLE: "LEGEND_TOGGLE"
};
